export default __webpack_public_path__ + "static/media/paper20.93db5300.JPG";